import { render, staticRenderFns } from "./StatusChart.vue?vue&type=template&id=23aa170c&scoped=true&"
import script from "./StatusChart.vue?vue&type=script&lang=js&"
export * from "./StatusChart.vue?vue&type=script&lang=js&"
import style0 from "./StatusChart.vue?vue&type=style&index=0&id=23aa170c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa170c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aa170c')) {
      api.createRecord('23aa170c', component.options)
    } else {
      api.reload('23aa170c', component.options)
    }
    module.hot.accept("./StatusChart.vue?vue&type=template&id=23aa170c&scoped=true&", function () {
      api.rerender('23aa170c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatusChart.vue"
export default component.exports